<script>
	import listBase from '@_system/components/base/list.vue'
	import enterIndex from './enter/index.vue'
	export default {
		extends: listBase,
		name: 'exchangeorder',
		props: {

		},
		render(h) {
			this.$slots.plug = [ 
				<enter-index title="录入" ref = "enterIndex" onSuccess={this.enterSuccess} /> , 				
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				moduleName: 'exchangeorder',
				windowName: '售后单',
				windowType: 'modal',
				pagerConfig: {
					enabled: true,
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 20,
					pageSizes: [10, 20, 50, 100, 200, 2000],
				},
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {
			
		},
		computed: {

		},

		methods: {
			enter(){
				this.$refs.enterIndex.modal_show()
			},
			enterSuccess(){
				this.customreload()
			},
			close(row){
				this.$confirm('是否确认关闭 ' + (row.code ? row.code : ''), '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.exchangeorder.closeexchange({id:row.id}).then(()=>{
						this.loading = false
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					},()=>{
						this.loading = false
					})
				}).catch(() => {
					this.loading = false
				})

			}
		},	
		components: {
			enterIndex
		}
	}
</script>